@if (cmsContentavailable) {
  <section
    class="col-12 col-xs-12 col-sm-7 col-md-12 left-section import_section"
    >
    @if (showSuccessMessage) {
      <div class="global-alerts">
        <div class="alert alert-info alert-dismissable getAccAlert">
          <button
            (click)="closeInfoAlert()"
            class="close closeAccAlert"
            aria-hidden="true"
            data-dismiss="alert"
            type="button"
            data-di-id="di-id-4f6d7b93-70563360">
            ×
          </button>
          <span class="alert-text">
            {{ 'importCart.successMessage' | cxTranslate }}
          </span>
        </div>
      </div>
    }
    <div class="col-md-6 import_title">
      <h3 class="import_title">{{ 'importCart.title' | cxTranslate }}</h3>
    </div>
    <div class="account_overview_import" id="leftCont-rightNav">
      <div [innerHtml]="cmsContent | safeHtml"></div>
      @if (numberOfColumnsError) {
        <strong class="import_error_1">
          {{ 'importCart.numberOfColumnsError' | cxTranslate }}
        </strong>
      }
      @if (incorrectColumnsError) {
        <strong class="import_error_2">
          {{ 'importCart.incorrectColumnsError' | cxTranslate }}
        </strong>
      }
      @if (noFileSelectedError) {
        <strong class="import_error_3">
          {{ 'importCart.noFileSelectedError' | cxTranslate }}
        </strong>
      }
      @if (incorrectFileFormatError) {
        <strong class="import_error_4">
          {{ 'importCart.incorrectFileFormatError' | cxTranslate }}
        </strong>
      }
    </div>
  </section>
}
